import React from 'react'
import { Editor } from '@tinymce/tinymce-react';
import "./style.css"
import { InputLabel } from '@material-ui/core';

const styles = {


    labelForm: {
        fontSize: 12,
        paddingBottom: 3,
    }
};
export default function CompView(props) {

    const { input: { value, onChange }, developer, disabled, visualizador, textoVazio, inline, label } = props
    const handleEditorChange = (content, editor) => {
        onChange(content);
    }
    let placeholder = disabled ? "" : textoVazio ? textoVazio : "Digite algo aqui..."


    let inlineUsar = inline === undefined ? true : inline;
    let disabledUsar = disabled
    if (visualizador && !developer) {
        inlineUsar = true
        disabledUsar = true
    }
    // console.log('inlineUsar',inlineUsar)
    if (!inlineUsar) {
        return (
            <div style={{ paddingBottom: 10 }}>
                {label && <InputLabel
                    style={styles.labelForm}
                >{label}</InputLabel>}

                <Editor
                    value={value}
                    disabled={disabledUsar}
                    apiKey="q2yj9emgr387nl1n4859h3mnw64hqct6bejt4f4nabjvghuu"
                    init={{
                        placeholder,
                        height: 500,
                        inline: inlineUsar,
                        language: 'pt_BR',
                        plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
                        toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',

                    }}

                    onEditorChange={handleEditorChange}
                />

            </div>


        )
    }
    return (

        <Editor
            value={value}
            disabled={disabledUsar}
            apiKey="q2yj9emgr387nl1n4859h3mnw64hqct6bejt4f4nabjvghuu"
            init={{
                placeholder,
                height: 500,
                inline: inlineUsar,
                plugins: 'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons',
                toolbar: 'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl',

            }}

            onEditorChange={handleEditorChange}
        />


    )
}
